import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './assets/css/bootstrap.min.css';
import './assets/css/agency.min.css'

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root')
);

